import React from 'react';
import { Link } from 'react-router-dom';
import { MapPin, Users } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import type { Venue } from '../types/venue';
import { StarRating } from './StarRating';

interface SimilarVenueCardProps {
  venue: Venue;
}

export const SimilarVenueCard: React.FC<SimilarVenueCardProps> = ({ venue }) => {
  const { t } = useTranslation();
  
  return (
    <Link 
      to={`/venues/${venue.id}`}
      className="bg-white rounded-xl overflow-hidden shadow-sm hover:shadow-md transition-shadow group"
    >
      <div className="relative h-48 overflow-hidden">
        <img 
          src={venue.image || venue.images?.[0]} 
          alt={venue.name} 
          className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-105"
        />
        {venue.recommended && (
          <div className="absolute top-3 left-3 bg-[#fabddf] text-[#2D2F4E] px-2 py-0.5 rounded-full text-xs font-semibold">
            ✨ {t('venues.recommended')}
          </div>
        )}
      </div>
      
      <div className="p-4">
        <div className="flex items-center">
          {[...Array(5)].map((_, index) => (
            <StarRating key={index} index={index} rating={venue.rating} size="sm" />
          ))}
        </div>
        
        <h3 className="font-semibold text-gray-800 mb-1 group-hover:text-[#2D2F4E] transition-colors">
          {venue.name}
        </h3>
        
        <div className="flex items-center text-sm text-gray-500 mb-2">
          <MapPin size={14} className="mr-1" />
          <span>{venue.city}, {t(`regions.${venue.region}`)}</span>
        </div>
        
        <div className="flex items-center text-sm text-gray-500">
          <Users size={14} className="mr-1" />
          <span>{venue.capacity.min}-{venue.capacity.max} {t('venues.capacity')}</span>
        </div>
      </div>
    </Link>
  );
}; 